import {
    SET_PROPM_LOCKBOX_INFO,
    SET_PROPM_INSPECTION,
    SET_PROPM_MAINTENACE_REPAIR,
    SET_PROPM_VIOLATIONS,
    SET_PROPERTY_FIELDS,
    SET_PROPERTY_UTILITY_VENDORS,
    SET_PROPM_UTILITY_VENDOR_REFERENCE
} from "../../types";
import { setAlert } from "../alert";
import { calcPropertyOccupiedVacantSpace } from "./properties";
import Axios from "axios";

//  TODO: Either merge all 4 functions into one function
//  TODO: Or Distribute them as if only when they needed to be load
//  TODO: TBD

//  DESC:setPropMLockboxInfo
//  DESC:This method gets fired when the application is loaded
//  DESC:It depends on property_management_lockbox_info from properties table
//  DESC:We pull property_management_lockbox_info from the global state
//  DESC:And of course this function gets fired after the global state is loaded
//  DESC:We defined Info as an Array to reserved memory also to set that state as
//  DESC:An empty array if property_management_lockbox_info is  falsy
//  DESC:property_management_lockbox_info comes back from server as a String
//  DESC:Therefore, JSON.parse comes in to convert into an actually object
export const setPropMLockboxInfo = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { property_management_lockbox_info } } } = getState();
        let Info = [];
        if (property_management_lockbox_info) {
            Info = JSON.parse(property_management_lockbox_info);
        }

        dispatch({
            type: SET_PROPM_LOCKBOX_INFO,
            payload: Info
        });
    }
    catch (error) {
        dispatch(setAlert("lockbox info error", "error"));
    }
};

//  DESC:setPropMInspection
//  DESC:This method gets fired when the application is loaded
//  DESC:It depends on property_management_inspections from properties table
//  DESC:We pull property_management_inspections from the global state
//  DESC:And of course this function gets fired after the global state is loaded
//  DESC:We defined Info as an Array to reserved memory also to set that state as
//  DESC:An empty array if property_management_inspections is  falsy
//  DESC:property_management_inspections comes back from server as a String
//  DESC:Therefore, JSON.parse comes in to convert into an actually object
export const setPropMInspection = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { property_management_inspections } } } = getState();
        let Info = [];
        if (property_management_inspections) {
            Info = JSON.parse(property_management_inspections);
        }

        dispatch({
            type: SET_PROPM_INSPECTION,
            payload: Info
        });
    }
    catch (error) {
        dispatch(setAlert("inspection log error", "error"));
    }
};

//  DESC:setPropMRepairMaintenace
//  DESC:This method gets fired when the application is loaded
//  DESC:It depends on property_management_maintenance_and_repairs from properties table
//  DESC:We pull property_management_maintenance_and_repairs from the global state
//  DESC:And of course this function gets fired after the global state is loaded
//  DESC:We defined Info as an Array to reserved memory also to set that state as
//  DESC:An empty array if property_management_maintenance_and_repairs is  falsy
//  DESC:property_management_maintenance_and_repairs comes back from server as a String
//  DESC:Therefore, JSON.parse comes in to convert into an actually object
export const setPropMRepairMaintenace = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { property_management_maintenance_and_repairs } } } = getState();
        let Info = [];
        if (property_management_maintenance_and_repairs) {
            Info = JSON.parse(property_management_maintenance_and_repairs);
        }

        dispatch({
            type: SET_PROPM_MAINTENACE_REPAIR,
            payload: Info
        });
    }
    catch (error) {
        dispatch(setAlert("repair and maintenance log error", "error"));
    }
};

//  DESC:setPropMViolation
//  DESC:This method gets fired when the application is loaded
//  DESC:It depends on property_management_violations from properties table
//  DESC:We pull property_management_violations from the global state
//  DESC:And of course this function gets fired after the global state is loaded
//  DESC:We defined Info as an Array to reserved memory also to set that state as
//  DESC:An empty array if property_management_violations is  falsy
//  DESC:property_management_violations comes back from server as a String
//  DESC:Therefore, JSON.parse comes in to convert into an actually object

export const setPropMViolation = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { property_management_violations } } } = getState();
        let Info = [];
        if (property_management_violations) {
            Info = JSON.parse(property_management_violations);
        }

        dispatch({
            type: SET_PROPM_VIOLATIONS,
            payload: Info
        });
    }
    catch (error) {
        dispatch(setAlert("violation log error", "error"));
    }
};

/**
 * @name    updateManagement
 * @param   event
 * @returns {function(...[*]=)}
 */

export const updateManagement = event => async(dispatch, getState) => {
    try {
    //  DESC:OCCUPANCY STATUS
        const { properties: { propertyFields } } = getState();
        //  DESC:Pre-defined an empty errors array
        const errors = [];

        //  DESC:Create new Property Fields Object and update it with new value
        let newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };

        //  DESC:Destructure necsserary values to use to update property fields
        //  DESC:Possible rename to use easier
        const {
            // property_management_leased_space :leased_space,
            // property_management_occupancy_status :status,
            // building_size,
            property_management_om_approval_date: om_approval_date,
            property_management_approval_for_3ppm,
            property_management_reason_for_3ppm
        } = newPropertyFields;

        //  DESC:Pre-defined Occupancy Status
        // const Unknown = 8;
        // const Vacant = 7;
        // const Occupied = 1;
        // const selection = false;
        const Yes = "Y";
        const No = "N";
        // const Income_Producing = 156;
        // const At_Risk = 157;
        const No_3PPM_Approval = 158;

        //  DESC:Checking for 3PPM Approval with No value
        //  DESC:set Approval Date to empty if status is No
        //  DESC:set Reason to No 3PPM Approval if status is No
        //  DESC:set Reason to empty if status is Yes
        if (property_management_approval_for_3ppm === No) {
            if (om_approval_date) {
                newPropertyFields.property_management_om_approval_date = "";
                errors.push(
                    "3PPM is not Approved. USMS Approval Date is removed."
                );
            }
            if (parseInt(property_management_reason_for_3ppm) !== No_3PPM_Approval) {
                newPropertyFields.property_management_reason_for_3ppm = No_3PPM_Approval;
                errors.push(
                    '3PPM is not Approved. Reason for 3PPM is set to "No 3PPM Approval".'
                );
            }
        }
        else if (property_management_approval_for_3ppm === Yes) {
            if (parseInt(property_management_reason_for_3ppm) === No_3PPM_Approval) {
                newPropertyFields.property_management_reason_for_3ppm = "";
                errors.push("3PPM is Approved. Please pick a Reason for 3PPM.");
            }
        }

        switch (event.target.name) {
            case "property_management_violations": {
            //  DESC:PROPERTY MANAGEMENT - MOST RECENT VIOLATION FIELDS
            //  DESC:Set violation values in properties table to recent one
            //  DESC:Parse the log into JSON object
                const ViolationLogs = JSON.parse(event.target.value);

                //  DESC:Select the latest log from the logs
                const LatestLog = ViolationLogs[ViolationLogs.length - 1];

                //  DESC:Destructure value from LastesLog
                //  DESC:And rename values
                const {
                    ["Notice Date"]: violation_notice_date,
                    ["Status"]: violation_status,
                    ["Reason"]: violation_reason,
                    ["Noticing Entity"]: violation_noticing_entity,
                    ["Remedy Start Date"]: violation_remedy_start_date,
                    ["Remedy"]: violation_remedy,
                    ["Description"]: violation_description
                } = LatestLog;

                //  DESC:If LatestLog has value - update newPropertyFields with new values
                //  DESC:If not - Set them all to empty
                if (LatestLog) {
                    newPropertyFields = {
                        ...newPropertyFields,
                        violation_notice_date,
                        violation_status,
                        violation_reason,
                        violation_noticing_entity,
                        violation_remedy_start_date,
                        violation_remedy,
                        violation_description
                    };
                }
                else {
                    newPropertyFields = {
                        ...newPropertyFields,
                        violation_description: "",
                        violation_notice_date: "",
                        violation_status: "",
                        violation_reason: "",
                        violation_noticing_entity: "",
                        violation_remedy_start_date: "",
                        violation_remedy: ""
                    };
                }
                break;
            }
            case "property_management_lockbox_info": {
            //  DESC: Logic for property_management_lockbox_info field.

                //  DESC: Take marketing_lockbox array and select the latest item in the array. Set newest lockbox code and lockbox description to regular fields.
                const marketingLockboxes = JSON.parse(event.target.value);
                const marketingLockbox = marketingLockboxes[0];

                // If there is no Code then remove from the fields
                if (marketingLockbox) {
                    const { Code, Description } = marketingLockbox;
                    newPropertyFields.marketing_lockbox_code = Code;
                    newPropertyFields.marketing_lockbox_description = Description;
                }
                else {
                    newPropertyFields.marketing_lockbox_code = "";
                    newPropertyFields.marketing_lockbox_description = "";
                }

                break;
            }
            default:
                break;
        }

        //  DESC:proceed to update value normally
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
        //  DESC:Throw warning if there is any
        if (errors.length > 0) {
            dispatch(setAlert(errors.toString(), "info"));
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
    finally {
        switch (event.target.name) {
            case "property_management_violations":
                dispatch(setPropMViolation());
                break;
            case "property_management_lockbox_info":
                dispatch(setPropMLockboxInfo());
                break;
            case "property_management_inspections":
                dispatch(setPropMInspection());
                break;
            case "property_management_maintenance_and_repairs":
                dispatch(setPropMRepairMaintenace());
                break;
            case "property_management_leased_space":
                dispatch(calcPropertyOccupiedVacantSpace());
                break;
            default:
                break;
        }
    }
};

/**
 * This updates the dropdown list for Utility Vendors in Utility Vendor Log
 * Upon changing Utility Type, only Utility Vendors for that type will be listed
 */
export const updateUtilityVendors = (utility) => async (dispatch, getState) => {
    try {
        const response = await Axios.get(
            `/vendors/utility/${utility}`
        );

        await dispatch({
            type: SET_PROPERTY_UTILITY_VENDORS,
            payload: response.data
        });
    } catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

export const setUtilityVendorReference = () => async (dispatch, getState) => {
    try {
        const {
            properties:
            {
                propertyData: {
                    utility_vendor_reference
                }
            }
        } = getState();
        await dispatch({
            type: SET_PROPM_UTILITY_VENDOR_REFERENCE,
            payload: utility_vendor_reference
        });
    } catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

/**
 * This updates the reference list of available Utility Vendors to display names in the list view
 */
export const updateUtilityVendorReference = (id) => async (dispatch, getState) => {
    try {
        const {
            propertyManagement: {
                UtilityVendorReference
            },
            properties: {
                propertyData: {
                    utility_vendors
                }
            }
        } = getState();
        let reference = UtilityVendorReference;
        let utilityVendor = utility_vendors.find(vendor => {
            return vendor.value === parseInt(id);
        });
        const isReferenced = reference.some(vendor => {
            return vendor.value === utilityVendor.value;
        });

        if (isReferenced) {
            return;
        }

        reference.push(utilityVendor);

        await dispatch({
            type: SET_PROPM_UTILITY_VENDOR_REFERENCE,
            payload: reference
        });
    } catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};
